import { useEffect, useState } from 'react';

import { getPreferredTheme, type ThemeMode } from '@/lib/theme';

function readTheme(): ThemeMode {
  if (typeof document === 'undefined') return 'light';
  const attribute = document.documentElement.getAttribute('data-theme');
  if (attribute === 'light' || attribute === 'dark') return attribute;
  return getPreferredTheme();
}

export function useTheme(): ThemeMode {
  const [theme, setTheme] = useState<ThemeMode>(readTheme);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setTheme(readTheme());
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme'],
    });

    return () => observer.disconnect();
  }, []);

  return theme;
}
